import { injectable } from 'inversify';

import { ProfileAccessModel, Restriction } from '@vp/profile/core/model/ProfileAccessModel';
import { RestrictedSection } from '@vp/profile/data/dto/ProfileResponseDto';

export interface UpdateAccesDto {
  config_attributes: {
    restricted_access_pin: string;
    restricted_sections: RestrictedSection[];
    fully_restricted: boolean;
  };
}

@injectable()
export class AccesssManagerDataMapper {
  private readonly restrictionMap: Record<Restriction, RestrictedSection> = {
    [Restriction.Bio]: RestrictedSection.Bio,
    [Restriction.Gallery]: RestrictedSection.Gallery,
    [Restriction.Honor]: RestrictedSection.Tributes,
    [Restriction.Events]: RestrictedSection.Timeline,
  };

  toPayloadDto(access: ProfileAccessModel): UpdateAccesDto {
    const restricted_sections: RestrictedSection[] = [];

    access.restrictions.forEach(restriction => {
      const section = this.restrictionMap[restriction];
      section && restricted_sections.push(section);
    });

    const fully_restricted = restricted_sections.length === ProfileAccessModel.allRestrictions.length;

    return {
      config_attributes: {
        fully_restricted,
        restricted_sections,
        restricted_access_pin: access.code,
      },
    };
  }
}
